import { defineMessages } from '@atlassian/jira-intl';

const messages: {
	modalHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jsmModalHeader: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jsmExplainWhatProjectRestoreDoes: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	confirmRestoreButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelRestoreButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restoreSuccessMessageTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restoreServiceDeskSuccessMessageTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restoreServiceDeskSuccessMessageContent: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restoreServiceDeskSuccessMessageActionEmailSettings: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restoreErrorMessageTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restoreErrorMessageDescription: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restoreErrorMessageDescriptionRenderErrorNonFinal: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restoreSuccessMessageTitleGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restoreServiceDeskSuccessMessageTitleGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restoreServiceDeskSuccessMessageContentGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restoreErrorMessageDescriptionGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	restoreErrorMessageDescriptionRenderErrorNonFinalGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	modalHeaderGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jsmModalHeaderGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	modalHeader: {
		id: 'project-restore-modal.modal-header',
		defaultMessage: 'Restore project?',
		description: 'The modal header for project restore action',
	},
	jsmModalHeader: {
		id: 'project-restore-modal.jsm-modal-header',
		defaultMessage: 'Restore this service project?',
		description: 'The modal header for project restore action',
	},
	jsmExplainWhatProjectRestoreDoes: {
		id: 'project-restore-modal.jsm-explain-what-project-restore-does',
		defaultMessage:
			'Once restored, this service project will work as normal. It will appear in directories and requests will appear in search results.',
		description: 'Explanation for restoring a project',
	},
	confirmRestoreButton: {
		id: 'project-restore-modal.confirm-restore-button',
		defaultMessage: 'Restore',
		description: 'Confirmation of project restore action',
	},
	cancelRestoreButton: {
		id: 'project-restore-modal.cancel-restore-button',
		defaultMessage: 'Cancel',
		description: 'Cancellation of project restore action',
	},
	restoreSuccessMessageTitle: {
		id: 'project-restore-modal.restore-success-message-title',
		defaultMessage: 'Project successfully restored',
		description: 'Title for success message when project is restored',
	},
	restoreServiceDeskSuccessMessageTitle: {
		id: 'project-restore-modal.restore-service-desk-success-message-title',
		defaultMessage: 'Service project restored',
		description: 'Title for success message when a service desk project is restored',
	},
	restoreServiceDeskSuccessMessageContent: {
		id: 'project-restore-modal.restore-service-desk-success-message-content',
		defaultMessage:
			'You may need to turn on email support for your service project to work as normal.',
		description: 'Content for success message when a service desk project is restored',
	},
	restoreServiceDeskSuccessMessageActionEmailSettings: {
		id: 'project-restore-modal.restore-service-desk-success-message-action-email-settings',
		defaultMessage: 'Go to email settings',
		description:
			'Title for action to go to email settings on success message when a service desk project is restored',
	},
	restoreErrorMessageTitle: {
		id: 'project-restore-modal.restore-error-message-title',
		defaultMessage: 'Something went wrong',
		description: 'Title for error message when project restore is failed',
	},
	restoreErrorMessageDescription: {
		id: 'project-restore-modal.restore-error-message-description',
		defaultMessage: 'We couldn’t restore the “{projectName}” project. Try again.',
		description: 'Description for error message when project restore is failed',
	},
	restoreErrorMessageDescriptionRenderErrorNonFinal: {
		id: 'project-restore-modal.restore-error-message-description-render-error-non-final',
		defaultMessage: 'We couldn’t restore the “{projectName}” project.{br}{error}',
		description:
			'Description for error message when project restore is failed. Includes the error that comes from the server',
	},
	restoreSuccessMessageTitleGalaxia: {
		id: 'project-restore-modal.restore-success-message-title-galaxia',
		defaultMessage: 'Space successfully restored',
		description: 'Title for success message when project is restored',
	},
	restoreServiceDeskSuccessMessageTitleGalaxia: {
		id: 'project-restore-modal.restore-service-desk-success-message-title-galaxia',
		defaultMessage: 'Service space restored',
		description: 'Title for success message when a service desk project is restored',
	},
	restoreServiceDeskSuccessMessageContentGalaxia: {
		id: 'project-restore-modal.restore-service-desk-success-message-content-galaxia',
		defaultMessage:
			'You may need to turn on email support for your service space to work as normal.',
		description: 'Content for success message when a service desk project is restored',
	},
	restoreErrorMessageDescriptionGalaxia: {
		id: 'project-restore-modal.restore-error-message-description-galaxia',
		defaultMessage: 'We couldn’t restore the “{projectName}” space. Try again.',
		description: 'Description for error message when project restore is failed',
	},
	restoreErrorMessageDescriptionRenderErrorNonFinalGalaxia: {
		id: 'project-restore-modal.restore-error-message-description-render-error-non-final-galaxia',
		defaultMessage: 'We couldn’t restore the “{projectName}” space.{br}{error}',
		description:
			'Description for error message when project restore is failed. Includes the error that comes from the server',
	},
	modalHeaderGalaxia: {
		id: 'project-restore-modal.modal-header-galaxia',
		defaultMessage: 'Restore space?',
		description: 'The modal header for project restore action',
	},
	jsmModalHeaderGalaxia: {
		id: 'project-restore-modal.jsm-modal-header-galaxia',
		defaultMessage: 'Restore this service space?',
		description: 'The modal header for project restore action',
	},
});
export default messages;
